import { render, staticRenderFns } from "./BaseNotify.vue?vue&type=template&id=30e44a6f&scoped=true&"
import script from "./BaseNotify.vue?vue&type=script&lang=js&"
export * from "./BaseNotify.vue?vue&type=script&lang=js&"
import style0 from "./BaseNotify.vue?vue&type=style&index=0&id=30e44a6f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e44a6f",
  null
  
)

export default component.exports